/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportConfigSlotRepresentation } from './ReportConfigSlotRepresentation';
import {
    ReportConfigSlotRepresentationFromJSON,
    ReportConfigSlotRepresentationFromJSONTyped,
    ReportConfigSlotRepresentationToJSON,
    ReportConfigSlotRepresentationToJSONTyped,
} from './ReportConfigSlotRepresentation';

/**
 * 
 * @export
 * @interface ReportConfigLayoutRepresentation
 */
export interface ReportConfigLayoutRepresentation {
    /**
     * 
     * @type {number}
     * @memberof ReportConfigLayoutRepresentation
     */
    page: number;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigLayoutRepresentation
     */
    layout: string;
    /**
     * 
     * @type {Array<ReportConfigSlotRepresentation>}
     * @memberof ReportConfigLayoutRepresentation
     */
    slots: Array<ReportConfigSlotRepresentation>;
}

/**
 * Check if a given object implements the ReportConfigLayoutRepresentation interface.
 */
export function instanceOfReportConfigLayoutRepresentation(value: object): value is ReportConfigLayoutRepresentation {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('layout' in value) || value['layout'] === undefined) return false;
    if (!('slots' in value) || value['slots'] === undefined) return false;
    return true;
}

export function ReportConfigLayoutRepresentationFromJSON(json: any): ReportConfigLayoutRepresentation {
    return ReportConfigLayoutRepresentationFromJSONTyped(json, false);
}

export function ReportConfigLayoutRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportConfigLayoutRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'layout': json['layout'],
        'slots': ((json['slots'] as Array<any>).map(ReportConfigSlotRepresentationFromJSON)),
    };
}

export function ReportConfigLayoutRepresentationToJSON(json: any): ReportConfigLayoutRepresentation {
    return ReportConfigLayoutRepresentationToJSONTyped(json, false);
}

export function ReportConfigLayoutRepresentationToJSONTyped(value?: ReportConfigLayoutRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'layout': value['layout'],
        'slots': ((value['slots'] as Array<any>).map(ReportConfigSlotRepresentationToJSON)),
    };
}

